import React, { Component } from 'react';

import styles from './default.less';

interface Props {
	children: React.ReactNode;
}

export default class Breadcrumbs extends Component<Props> {
	static defaultProps = {
		children: null,
	};

	render() {
		const { children } = this.props;

		return (
			<div className={styles.breadcrumbs}>
				<div className={styles.in}>
					<ul className={styles.list}>{children}</ul>
				</div>
			</div>
		);
	}
}
